module.exports = __webpack_public_path__ + "img/Pista_00_2.1262d696.png";